import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';
import TituloComponent from '../../components/Titulo/TituloComponent';
import '../../styles/global.css';
import './FazerCheckinPorQrCode.css';
import { fazerCheckin, buscarDadosEstabelecimentoById } from '../../services/api';
import Cookies from 'js-cookie';

const FazerCheckinPorQrCode = () => {
  const navigate = useNavigate();
  const { numeroMesa, idEstabelecimento } = useParams();

  const [dadosEstabelecimento, setDadosEstabelecimento] = useState(null);
  const [dadosCheckin, setDadosCheckin] = useState(null);
  const [checkinRealizado, setCheckinRealizado] = useState(false); // 👈 controle

  // 1️⃣ Carrega dados do estabelecimento e prepara o check-in
  useEffect(() => {

    console.log('Entrou no useEffect 1');

    const carregarEstabelecimento = async () => {
      if (!idEstabelecimento) return;

      console.log('ok, id estabelecimento carregado = ');
      console.log(idEstabelecimento);

      try {

        console.log('... vai buscar os dados do estabelecimento pelo id...');

        const resposta = await buscarDadosEstabelecimentoById({ idEstabelecimento });
        const estabelecimento = resposta?.dadosEstabelecimento?.[0];

        console.log('Estabelecimento: ');
        console.log(estabelecimento);

        if (estabelecimento) {

          console.log('ok! estabelecimento carregado! ');

          setDadosEstabelecimento(estabelecimento);

          const dadosPadrao = {
            estabelecimento: {
              id: estabelecimento.id,
              nome: estabelecimento.nome
            },
            numeroMesa: numeroMesa,
            nomeEstabelecimento: estabelecimento.nome,
            statusCheckin: 'usuarioCheckado',
            objBarcheckin: {},
          };

          console.log('Dados padrão: ');
          console.log(dadosPadrao);
          console.log('... vai carregar os dados checkin = dados padrão....');

          Cookies.set('dadosCheckin', JSON.stringify(dadosPadrao));
          setDadosCheckin(dadosPadrao);

          console.log('Dados checkin: ');
          console.log(dadosCheckin);

        }
      } catch (error) {
        console.error('Erro ao buscar dados do estabelecimento:', error);
      }
    };

    console.log('... vai carregar os dados do estabelecimento... ');

    carregarEstabelecimento();
  }, [idEstabelecimento, numeroMesa]);

  // 2️⃣ Faz o check-in apenas uma vez
  useEffect(() => {

    console.log('Entrou em useEffect 2 ...');

    if (!dadosCheckin || checkinRealizado) return;

    console.log('ok, dados checkin! ');
    console.log('.. vai fazer checkin por qr code....');

    handleFazerCheckinPorQrCode();
  }, [dadosCheckin, checkinRealizado]);

  const handleFazerCheckinPorQrCode = async () => {
    console.log('---------------------------------------');
    console.log('---- ENTROU NO handleFazerCheckinPorQrCode ----');
    console.log('Fazendo Checkin... dadosCheckin:', dadosCheckin);

    try {
      const response = await fazerCheckin(dadosCheckin);
      const message = response.message;

      console.log('Response recebido: ');
      console.log(response);

      console.log('Mensagem recebida: ');
      console.log(message);

      setDadosCheckin((prevState) => ({
        ...prevState,
        statusCheckin: 'usuarioCheckado',
        numeroMesa: numeroMesa
      }));

      const checkinData = {
        estabelecimento: dadosCheckin.estabelecimento,
        objBarcheckin: response.objBarcheckin,
        statusCheckin: 'usuarioCheckado',
        numeroMesa: numeroMesa
      };

      sessionStorage.setItem('dadosCheckin', JSON.stringify(checkinData));

      const date = new Date();
      date.setTime(date.getTime() + 30 * 24 * 60 * 60 * 1000); // 30 dias
      Cookies.set('dadosCheckin', JSON.stringify(checkinData), { expires: date });

      setCheckinRealizado(true); // 👈 evita segunda execução
      alert(message);
      navigate('/');
    } catch (error) {
      console.error('Erro ao fazer check-in:', error);
      const errorMessage = error.response?.data?.message ?? 'Erro ao fazer check-in. Tente novamente.';

      sessionStorage.setItem('dadosCheckin', JSON.stringify({
        estabelecimento: dadosCheckin.estabelecimento,
        statusCheckin: 'usuarioNaoCheckado',
      }));

      alert(errorMessage);
    }
  };

  const atualizarDadosCheckinCookies = () => {
    const dadosCheckinStr = Cookies.get('dadosCheckin');

    if (!dadosCheckinStr) {
      console.error('Cookie dadosCheckin não encontrado.');
      return;
    }

    try {
      const dadosObj = JSON.parse(dadosCheckinStr);

      if (dadosObj.objBarcheckin) {
        dadosObj.objBarcheckin.numero_mesa = numeroMesa;
        dadosObj.numeroMesa = numeroMesa;

        Cookies.set('dadosCheckin', JSON.stringify(dadosObj));
        console.log('ok, dados atualizados');
      } else {
        console.error('objBarcheckin não encontrado em dadosCheckin.');
      }
    } catch (error) {
      console.error('Erro ao fazer parse do cookie dadosCheckin:', dadosCheckinStr);
    }
  };

  return (
    <div autoFocus className="bar-gerente-container">
      <TituloComponent />
      <h1 className="sub-titulo">Checkin por QrCode</h1>

      {dadosEstabelecimento && (
        <div className="info-estabelecimento">
          <h2>Bem-vindo ao {dadosEstabelecimento.nome}</h2>
          <p>{dadosEstabelecimento.endereco}, {dadosEstabelecimento.cidade} - {dadosEstabelecimento.uf}</p>
        </div>
      )}
    </div>
  );
};

export default FazerCheckinPorQrCode;
